import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Select } from 'components/Form'
import { createApiRecord, updateApiRecord } from 'services/AssignService'
import { useDispatch, useSelector } from 'react-redux'
import { getRecord } from './store/dataSlice'
import reducer from './store'
import { injectReducer } from 'store'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { Success } from 'utils/alerts'
import {
    getTransportProviderData,
    getTransportProviderServiceData,
} from 'store/data/dataSlice'
injectReducer('assign', reducer)

const validationSchema = Yup.object().shape({
    client: Yup.number().required('Please select company'),
    transport_provider: Yup.number().required(
        'Please select transport provider',
    ),
    service: Yup.number().required('Please select tranport provider services'),
})

const Create = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {
        clientCompanyData,
        transportProviderData,
        transportProviderServiceData,
    } = useSelector((state) => state.listData)
    const { view, record, loading } = useSelector((state) => state.assign.data)

    useEffect(() => {
        if (id) {
            fetchData(id)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const fetchData = (id) => dispatch(getRecord(id))

    const handleDiscard = () => navigate('/master-data/assign')

    const handleSubmit = (values, setSubmitting) => {
        setSubmitting(true)
        if (id) {
            updateApiRecord(id, values)
                .then(() => {
                    Success('Updated Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        } else {
            createApiRecord(values)
                .then(() => {
                    Success('Created Successfully!')
                    handleDiscard()
                    // dispatch(getCompanyData())
                    setSubmitting(false)
                })
                .catch((error) => {
                    setSubmitting(false)
                    return error
                })
        }
    }

    if (loading) {
        return null
    }

    return (
        <>
            <div className="flex flex-col gap-1 mb-3 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Fuel Levy
                </h2>
            </div>
            <div className="flex flex-col items-center">
                <div className="w-full bg-white border rounded-lg border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                    <div className="px-5 py-3 border-b border-stroke dark:border-strokedark">
                        <h3 className="font-medium text-black dark:text-white">
                            {id ? 'Update Fuel Levy' : 'Add New Fuel Levy'}
                        </h3>
                    </div>
                    <div className="flex flex-col gap-3 p-6">
                        <Formik
                            initialValues={id ? record : view}
                            validationSchema={validationSchema}
                            onSubmit={(values, { setSubmitting }) => {
                                handleSubmit(values, setSubmitting)
                            }}
                        >
                            {({ values, touched, errors, isSubmitting }) => (
                                <Form>
                                    <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-6">
                                        <Field name="client">
                                            {({ field, form }) => (
                                                <Select
                                                    options={clientCompanyData?.map(
                                                        (item) => ({
                                                            label: `${item?.company?.name} ${
                                                                item?.client
                                                                    ?.name
                                                                    ? `(${item?.client?.name})`
                                                                    : ''
                                                            }`,
                                                            value: item?.id,
                                                        }),
                                                    )}
                                                    label="Company/Client"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="client"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.client &&
                                                        touched.client
                                                    }
                                                    message={errors.client}
                                                    value={values?.client}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                        form.setFieldValue(
                                                            'transport_provider',
                                                            '',
                                                        )
                                                        form.setFieldValue(
                                                            'service',
                                                            '',
                                                        )
                                                        dispatch(
                                                            getTransportProviderData(),
                                                        )
                                                        dispatch(
                                                            getTransportProviderServiceData(),
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="transport_provider">
                                            {({ field, form }) => (
                                                <Select
                                                    options={transportProviderData?.filter(
                                                        (item) =>
                                                            item.type ===
                                                            'Aggregator',
                                                    )}
                                                    label="Transport Provider"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="transport_provider"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.transport_provider &&
                                                        touched.transport_provider
                                                    }
                                                    message={
                                                        errors.transport_provider
                                                    }
                                                    value={
                                                        values?.transport_provider
                                                    }
                                                    disabled={!values?.client}
                                                    onChange={(e) => {
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }}
                                                />
                                            )}
                                        </Field>
                                        <Field name="service">
                                            {({ field, form }) => (
                                                <Select
                                                    options={
                                                        transportProviderServiceData
                                                    }
                                                    label="Transport Provider Service"
                                                    size="sm"
                                                    placeholder="Select"
                                                    name="service"
                                                    className="md:col-span-2"
                                                    error={
                                                        errors.service &&
                                                        touched.service
                                                    }
                                                    message={errors.service}
                                                    value={values?.service}
                                                    disabled={!values?.client}
                                                    onChange={(e) =>
                                                        form.setFieldValue(
                                                            field.name,
                                                            e.target.value,
                                                        )
                                                    }
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <div className="flex items-center justify-end gap-4 mt-3">
                                        <Button
                                            className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                            onClick={handleDiscard}
                                        >
                                            Discard
                                        </Button>
                                        <Button
                                            type="submit"
                                            className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            disabled={isSubmitting}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Create
